import { orderBy } from "firebase/firestore";
import { kTimestamp } from "./strings";

export const sortByDate = () => orderBy(kTimestamp, "desc");
